import { CityResponse } from '../types/api-responses/city-response'
import { CityModel } from '../types/models/city.model'

export function cityResolver(city: CityResponse): CityModel
export function cityResolver(city: CityResponse[]): CityModel[]

export function cityResolver(
  city: CityResponse | CityResponse[],
): CityModel | CityModel[] {
  if (Array.isArray(city)) {
    return city.map(resolveCity)
  }
  return resolveCity(city)
}

function resolveCity(city: CityResponse): CityModel {
  return {
    id: city.id,
    name: city.name,
    countryId: parseInt(city.country_id.toString()),
    countryFlag: city.country_flag,
    latitude: city.latitude?.toString(),
    countryName: city.country_name,
    stateName: city.state_name,
    timeZone: city.timezone,
    longitude: city.longitude?.toString(),
  }
}
